/**
 * @file       language-select/style.css
 * @author     Robert Mirandola <robert@distributive.network>
 *
 * @date       December 2022
 *
 *             Styling related to LanguageSelect component.
 */

#accountSelectHeader{
  padding-top: 0.7em;
}

#langSelect {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}

#lang {
  margin-right: 2em;
  position: relative;
  min-width: 8em;
  width: 28%;
  font-weight: bold;
  height: 3em;
  padding: 0.4em 1em 0.2em;
  border-radius: 0;
  box-sizing: border-box;
  color: #8a8a8a;
}

.animated-ellipsis span {
  opacity: 0;
  animation: ellipsisDot 1s infinite;
}

.animated-ellipsis span:nth-child(1) {
  animation-delay: 0s;
}

.animated-ellipsis span:nth-child(2) {
  animation-delay: 0.1s;
}

.animated-ellipsis span:nth-child(3) {
  animation-delay: 0.2s;
}

@keyframes ellipsisDot{
  0% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@media only screen and (max-width: 480px) {
  #langSelect {
    display: block;
  }

  #lang {
    width: 100%;
  }

  #langSave {
    margin-top: 3%;
  }
}
